export default "__VITE_ASSET__BhKAj5A0__"